import { Id } from "@dgs/core";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { filterService } from "../api/filter";

export const useResetFilterQueries = (keysToInvalidate?: string[][]) => {
	const queryClient = useQueryClient();
	const resetFilterQueries = useCallback(
		(id: Id) => {
			void queryClient.invalidateQueries({ queryKey: filterService.showKey(id) });
			void queryClient.resetQueries({ queryKey: filterService.optionsKey });
			keysToInvalidate && keysToInvalidate.forEach((key) => queryClient.invalidateQueries({ queryKey: key }));
		},
		[keysToInvalidate, queryClient],
	);

	return { resetFilterQueries };
};
